// Generated by Melange

import * as Belt__Belt_List from "melange.belt/belt_List.js";
import * as Buhta_cabinet__AuthTemplate from "../../templates/AuthTemplate.js";
import * as Buhta_cabinet__Input from "../../components/html/Input.js";
import * as Buhta_cabinet__RegisterForm from "./RegisterForm.js";
import * as Buhta_cabinet__Route from "../../Route.js";
import * as Buhta_components__CountryIcon from "../../../../../packages/components/src/atoms/CountryIcon.js";
import * as Buhta_components__Text from "../../../../../packages/components/src/html/Text.js";
import * as Caml_js_exceptions from "melange.js/caml_js_exceptions.js";
import * as Caml_string from "melange.js/caml_string.js";
import * as Curry from "melange.js/curry.js";
import * as StaticAsset from "../../../../../packages/util/lib/StaticAsset.js";
import * as Stdlib from "melange/stdlib.js";
import * as Stdlib__String from "melange/string.js";
import * as React from "react";
import * as JsxRuntime from "react/jsx-runtime";

function make(name) {
  return function (info) {
    return function (logo) {
      return function (onClick) {
        return function (country) {
          return JsxRuntime.jsxs("div", {
                      children: [
                        JsxRuntime.jsxs("div", {
                              children: [
                                JsxRuntime.jsx("div", {
                                      children: JsxRuntime.jsx(Buhta_components__Text.H3.make, {
                                            className: "text-white",
                                            children: logo
                                          }),
                                      className: "w-12 h-12 rounded-full bg-default-gray flex items-center justify-center shrink-0"
                                    }),
                                JsxRuntime.jsxs("div", {
                                      children: [
                                        JsxRuntime.jsx(Buhta_components__Text.H4.make, {
                                              children: name
                                            }),
                                        JsxRuntime.jsx(Buhta_components__Text.PSmall.make, {
                                              className: "text-gray-medium",
                                              children: info
                                            })
                                      ],
                                      className: "ml-4"
                                    })
                              ],
                              className: "flex items-center"
                            }),
                        JsxRuntime.jsx("div", {
                              children: JsxRuntime.jsx(Buhta_components__CountryIcon.make, {
                                    country: country
                                  }),
                              className: "shrink-0"
                            })
                      ],
                      className: "flex py-3 px-6 items-center cursor-pointer hover:bg-gray-pale justify-between",
                      onClick: onClick
                    });
        };
      };
    };
  };
}

function OrgChoosePage$OrgItem(Props) {
  return Curry._3(make(Props.name)(Props.info), Props.logo, Props.onClick, Props.country);
}

const OrgItem = {
  make: OrgChoosePage$OrgItem
};

function onTenantChoose(tenant) {
  Buhta_cabinet__Route.navigateTo({
        TAG: /* Org */6,
        _0: tenant.id,
        _1: /* Dashboard */0
      });
}

function nameTrimmed(name) {
  const name$1 = name.replace(/[^a-zA-Z0-9Ёёа-яА-Я-әғқңөұүһіІі.,\s-]/g, "").trim();
  return Belt__Belt_List.reduce({
                hd: "ип",
                tl: {
                  hd: "тоо",
                  tl: {
                    hd: "too",
                    tl: {
                      hd: "жшс",
                      tl: {
                        hd: "жшc",
                        tl: {
                          hd: "жк",
                          tl: {
                            hd: "жеке кәсіпкер",
                            tl: {
                              hd: "жауапкершілігі шектеулі серіктестік",
                              tl: {
                                hd: "товарищество с ограниченной ответственностью",
                                tl: {
                                  hd: "индивидуальный предприниматель",
                                  tl: /* [] */0
                                }
                              }
                            }
                          }
                        }
                      }
                    }
                  }
                }
              }, name$1, (function (name, currentNameToDelete) {
                  if (name.toLowerCase().indexOf(currentNameToDelete, undefined) === 0) {
                    return name.slice(currentNameToDelete.length, undefined);
                  } else {
                    return name;
                  }
                })).trim();
}

function OrgChoosePage(Props) {
  let profile = Props.profile;
  const match = React.useState(function () {
        return "";
      });
  const setSearchText = match[1];
  const searchText = match[0];
  const __x = profile.tenants;
  const __x$1 = Belt__Belt_List.keepMap(__x, (function (tenant) {
          const match = tenant.tenant;
          if (match === undefined) {
            return ;
          }
          const match$1 = match.info;
          if (typeof match$1 === "string" || match$1.NAME !== "Org") {
            return ;
          } else {
            return match$1.VAL;
          }
        }));
  const results = Belt__Belt_List.keep(__x$1, (function (t) {
          return t.name.toLowerCase().includes(searchText.toLowerCase(), undefined);
        }));
  const match$1 = profile.tenants;
  return JsxRuntime.jsx(Buhta_cabinet__AuthTemplate.make, {
              children: match$1 ? JsxRuntime.jsxs("div", {
                      children: [
                        JsxRuntime.jsxs(Buhta_components__Text.H4.make, {
                              className: "text-center relative",
                              children: [
                                "Выберите предприятие",
                                JsxRuntime.jsx("a", {
                                      children: JsxRuntime.jsx("img", {
                                            src: StaticAsset.src("/static/icons/logout.svg")
                                          }),
                                      className: "absolute right-3",
                                      href: "/auth/logout"
                                    })
                              ]
                            }),
                        JsxRuntime.jsx("hr", {
                              className: "mt-3"
                            }),
                        JsxRuntime.jsxs("div", {
                              children: [
                                JsxRuntime.jsx("img", {
                                      className: "w-5 h-5 ",
                                      alt: "search",
                                      src: StaticAsset.src("/static/icons/search.svg")
                                    }),
                                JsxRuntime.jsx(Buhta_cabinet__Input.make, {
                                      className: "sm:text-base h-6",
                                      value: searchText,
                                      placeholder: "Поиск...",
                                      onChange: (function (value) {
                                          Curry._1(setSearchText, (function (param) {
                                                  return value;
                                                }));
                                        })
                                    })
                              ],
                              className: "flex items-center pl-6 w-full gap-1 mt-3"
                            }),
                        JsxRuntime.jsx("hr", {
                              className: "mt-3"
                            }),
                        Belt__Belt_List.toArray(Belt__Belt_List.mapWithIndex(results, (function (index, tenant) {
                                    const name = tenant.name;
                                    const match = tenant["type'"];
                                    const tinLabel = match !== 1 && match !== 10 ? "БИН" : "ИИН";
                                    const tin = tenant.tin;
                                    const country = tenant.country;
                                    const logo = nameTrimmed(tenant.name);
                                    let logo_letter;
                                    let exit = 0;
                                    let first_letter;
                                    try {
                                      first_letter = Caml_string.get(logo, 0);
                                      exit = 1;
                                    }
                                    catch (raw_exn){
                                      const exn = Caml_js_exceptions.internalToOCamlException(raw_exn);
                                      if (exn.MEL_EXN_ID === Stdlib.Invalid_argument) {
                                        logo_letter = "B";
                                      } else {
                                        throw new Caml_js_exceptions.MelangeError(exn.MEL_EXN_ID, exn);
                                      }
                                    }
                                    if (exit === 1) {
                                      logo_letter = Stdlib__String.make(1, first_letter);
                                    }
                                    const Key = "org-item-" + String(index);
                                    return JsxRuntime.jsx(OrgChoosePage$OrgItem, {
                                                name: "" + name,
                                                info: "" + tinLabel + ": " + tin,
                                                logo: logo_letter,
                                                onClick: (function (param) {
                                                    onTenantChoose(tenant);
                                                  }),
                                                country: country
                                              }, Key);
                                  })))
                      ],
                      className: "bg-white rounded-md shadow py-3 max-h-full overflow-auto"
                    }) : JsxRuntime.jsx(Buhta_cabinet__RegisterForm.WaitForActivation.make, {})
            });
}

const make$1 = OrgChoosePage;

export {
  OrgItem ,
  onTenantChoose ,
  nameTrimmed ,
  make$1 as make,
}
/* Buhta_cabinet__AuthTemplate Not a pure module */
